import { useContext } from 'react';

// components
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { InteractiveDescriptionContext } from '../context';
import { truncateAtWordBoundary } from 'utils/truncate';

export function DescriptionDefault() {
  const { contentHeadline } = useContext(InteractiveDescriptionContext);

  return (
    <div className="interactive-description__content small-12">
      {contentHeadline && (
        <InnerHtml as="h4" content={truncateAtWordBoundary(contentHeadline, 50)} />
      )}
    </div>
  );
}
